if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.form) {
          this.form.querySelector('[name=id]').disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.quickViewOptions = this.submitButton?.closest('quick-view-options');
        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      
      isSelectedSwatch = (evt) => {
        let swatch
        if (document.querySelector('variant-radios .variant-swatch-input')) {
          swatch = document.querySelector('variant-radios .variant-swatch-input:checked')
        } else if(evt.target?.querySelector('.product-variant-id')?.value) {
          swatch = evt.target.querySelector('.product-variant-id').value
        }

        let errormsg = document.querySelector(".product-section-overview variant-radios .error-msg")
        if(swatch){
          return true
        }
        else {
          errormsg?.classList.remove("d-none")
          setTimeout(()=>{
            errormsg?.classList.add("d-none")
          },4000)
          return false
        }
      };

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;
        if(this.submitButton?.closest('.main-product-frm')){
          if(this.isSelectedSwatch(evt) === false) return;
        }
        
        this.handleErrorMessage();
        this.alreadyInCart = false;
        this.submitButton?.setAttribute('aria-disabled', true);
        this.submitButton?.classList.add('loading');
        if (this.quickViewOptions) {
          this.submitButtonText.innerText = 'Adding To cart';
        }
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              if (this.quickViewOptions && response.status == 422 && response.description) {
                this.alreadyInCart = true;
              }
              const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            shippingMessageUpdate();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            if (this.quickViewOptions) {
              if (this.alreadyInCart) {
                this.submitButtonText.innerText = 'Add To cart';
                this.submitButton?.classList.add('disabled');
              }else {
                this.submitButtonText.innerText = 'Added To cart';
              }
              setTimeout(() => {
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.submitButton?.classList.remove('loading');
                this.submitButtonText.innerText = 'Add to cart';
              }, 2000);
            }else {
              this.submitButton?.classList.remove('loading');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__text-danger-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__text-danger');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
